const Footer = () => {
    return (
      <footer className="bg-gray-800 text-white py-3 sm:py-4">
        <div className="container mx-auto px-2 sm:px-4 text-center">
          <p className="text-sm sm:text-base">&copy; 2023 DSA Visualizer. All rights reserved.</p>
        </div>
      </footer>
    )
  }
  
  export default Footer
  
  